import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupRestrictedContentProps } from './msg-group-restricted-content';
import { MsgGroupRestrictedContent } from './msg-group-restricted-content';

export interface MsgGroupRestrictedProps extends MsgGroupRestrictedContentProps {}

export const MsgGroupRestricted = memo(function MsgGroupRestricted({
  message,
}: MsgGroupRestrictedProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupRestrictedContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
